module.exports = __webpack_public_path__ + "static/media/personal_folder_tip_2.5dd3ab34.png";